import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Page from './page';

import Cookies from 'js-cookie'
import PublicApiClient from './public_api_client';
const uuid = require("uuid/v4");


console.log("TODO TODO TODO FIXME FIXME FIXME");
let domainBase = window.location.hostname.replace(/www./, ""); // Temporary, FIXME.
const publicApiDomain = `api.${domainBase}`;
const sessionCookieName = "checkoutSessionCookie";

export default class App extends React.Component {

  constructor(props) {
    super(props);
    this.api = new PublicApiClient({ publicApiDomain: publicApiDomain });
    window.api = this.api;
    this.state = {
      sessionCookie: this.getSessionCookie()
    }
  }

  getSessionCookie() {
    let   cookieValue = Cookies.get(sessionCookieName);

    if ((new URLSearchParams(window.location.search)).get("reset")) {
      cookieValue = undefined;
    }

    if (cookieValue === undefined) {
      cookieValue = uuid();
      Cookies.set(sessionCookieName, cookieValue);
    }
    return cookieValue;
  }


  render() {
    return (
      <Page api={this.api} templatesDomain={domainBase} />
    );

  }
}
